import React, { FC, useEffect } from "react";

type Props = {
  size?: number;
  stroke?: number;
  strokeLength?: number;
  color?: string;
  speed?: number;
  bgOpacity?: number;
};

const RingLoader: FC<Props> = ({
  size = 24,
  stroke = 1.5,
  strokeLength = 0.4,
  color = "black",
  speed = 0.8,
  bgOpacity = 0,
}) => {
  useEffect(() => {
    async function getLoader() {
      const { ring2 } = await import("ldrs");
      ring2.register();
    }
    getLoader();
  }, []);

  return (
    <l-ring-2
      size={size}
      stroke={stroke}
      stroke-length={strokeLength}
      bg-opacity={bgOpacity}
      speed={speed}
      color={color}
    ></l-ring-2>
  );
};

export default RingLoader;
